import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/careersLeadSearch";
import deltas from "../../actions/deltas";

const {SET_CAREERS_LEAD_SEARCH_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.STATIC, SET_CAREERS_LEAD_SEARCH_STATE);
